import React, { useState, useEffect, useContext } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Card from "react-bootstrap/Card";
import Store from "../../../redux";
import Form from "react-bootstrap/Form";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { QRCodeSVG } from "qrcode.react";
import {
  Copy,
  QrCode,
  Share2,
  Gift,
  Users,
  DollarSign,
  TrendingUp,
  Clock,
  MessageCircle,
  Facebook,
  Twitter,
} from "lucide-react";
import "./refer.scss"; 
import { Grid } from "@material-ui/core";
import { WhatsApp } from "@material-ui/icons";
import AppContext from "context/Context";
import { getReferralEarnings } from "api/dataApi";
import { useToast } from "components/common/custom-toast/Toast";

const Refer = () => {
  const {
    config: { isDark },
  } = useContext(AppContext);
  const [referralCodeUrl, setReferralCodeUrl] = useState("");
  const [showQR, setShowQR] = useState(false);
  const [userID, setUserID] = useState("");
  const [referralData, setReferralData] = useState(null);
  const toast = useToast()

  useEffect(() => {
    const user = Store?.getState()?.user;
    if (user?.userID) {
      setUserID(user.userID);
      const url = `${window.location.origin}/authentication/register?rc=${user.userID}`;
      setReferralCodeUrl(url);
    }
  }, []);

  useEffect(() => {
    const fetchReferralData = async () => {
      try {
        const response = await getReferralEarnings();
        console.log('API Response:', response);
        
        if (response && response.data) {
          setReferralData(response.data);
        }
      } catch (error) {
        console.error('Error fetching referral data:', error);
        toast.error('Failed to load referral data', {
          position: "top-right",
          autoClose: 3000,
        });
      } finally {
      }
    };

    fetchReferralData();
  }, []);

  const handleCopyCode = () => {
    toast.success("Referral code copied successfully!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  const handleCopyLink = () => {
    toast.success("Referral link copied successfully!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  // Calculate totals from API data
  const totalEarnings = referralData?.totalEarnings || 0;
  const totalLeads = referralData?.totalUsersReferred || 0; 
  const totalConversion = referralData?.totalSubscriptionsMadeByUsers || 0;
  const inProgress = totalLeads - totalConversion;

  // Get referral earnings array
  const referralEarnings = referralData?.referralEarnings || [];

  // Calculate stats from API data directly
  const activeUsers = referralEarnings.filter(earning => earning.paymentStatus === 'success').length;
  const pendingUsers = referralEarnings.filter(earning => earning.paymentStatus !== 'success').length;
  const totalUsers = referralEarnings.length;

const handleWhatsAppShare = () => {
  const message = `🚀 Dive into the world of options with FNOTrader – your all-in-one platform for analytics + execution!
📈 Smarter trades, faster insights.
🎁 Use my referral link to get started: ${referralCodeUrl}
🔗 Let's trade smarter, together!`;

  const encodedMessage = encodeURIComponent(message);
  window.open(`https://api.whatsapp.com/send?text=${encodedMessage}`, "_blank");
};

const handleFacebookShare = () => {
  const url = encodeURIComponent(referralCodeUrl);
  const text = encodeURIComponent(`🚀 Dive into the world of options with FNOTrader – your all-in-one platform for analytics + execution!
📈 Smarter trades, faster insights.
🎁 Use my referral link to get started!
🔗 Let's trade smarter, together!`);
  
  window.open(
    `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${text}`,
    "_blank",
  );
};

  const handleTwitterShare = () => {
    const text = encodeURIComponent(
      `🚀 Dive into the world of options with FNOTrader – your all-in-one platform for analytics + execution!
📈 Smarter trades, faster insights.
🎁 Use my referral link to get started: ${referralCodeUrl}
🔗 Let's trade smarter, together!`
    );
    const url = encodeURIComponent(referralCodeUrl);
        window.open(
      `https://twitter.com/intent/tweet?text=${text}`,
      "_blank"
    );
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === '_') return '_';
    try {
      return new Date(dateString).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    } catch (error) {
      return dateString;
    }
  };

  const getUserName = (userDetail) => {
    if (!userDetail) return '_';
    const firstName = userDetail.firstName || '';
    const lastName = userDetail.lastName || '';
    return `${firstName} ${lastName}`.trim() || '_';
  };

  const getPaymentStatus = (paymentStatus) => {
    return paymentStatus === 'success' ? 'Active' : 'Pending';
  };


  return (
    <div>
      <Card data-theme={isDark ? "dark" : "light"}>
        <div className="referral-header">
          <div className="referral-header-content">
            <div className="referral-icon">
              <Gift size={40} />
            </div>
            <div>
              <h3 className="referral-title">Referral Program</h3>
              <p className="referral-subtitle">
                Invite friends and earn rewards when they join our platform
              </p>
            </div>
          </div>
        </div>

        <Card.Body style={{padding: "1rem"}} className="referral-body">
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <div className="qr-section">
                <h5 className="section-title">Your Referral Link</h5>
                <div className="qr-container">
                  <div className="qr-code-wrapper">
                    <QRCodeSVG
                      value={referralCodeUrl}
                      size={200}
                      level="H"
                      includeMargin={true}
                      className="qr-code"
                    />
                  </div>
                  <p className="qr-description">
                    Share this QR code for easy access to your referral link
                  </p>
                </div>

                {/* Referral Link Section */}
                <Form.Group className="referral-input-group">
                  <div className="input-with-copy">
                    <Form.Control
                      type="text"
                      value={referralCodeUrl}
                      readOnly
                      className="referral-link-input"
                    />
                    <CopyToClipboard text={referralCodeUrl}>
                      <button className="copy-btn" onClick={handleCopyLink}>
                        <Copy size={16} />
                      </button>
                    </CopyToClipboard>
                  </div>
                </Form.Group>

                <div className="social-sharing">
                  <h6 className="sharing-title">Share via</h6>
                  <div className="sharing-buttons">
                    <button
                      className="share-button whatsapp"
                      onClick={handleWhatsAppShare}
                      title="Share on WhatsApp"
                    >
                      <WhatsApp />
                    </button>
                    <button
                      className="share-button facebook"
                      onClick={handleFacebookShare}
                      title="Share on Facebook"
                    >
                      <Facebook size={24} />
                    </button>
                    <button
                      className="share-button x"
                      onClick={handleTwitterShare}
                      title="Share on X"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <svg
                        style={{ width: "24px", height: "24px" }}
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 512 512"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </Grid>

            <Grid item xs={12} md={6}>
             <div className="steps-container">
                <h2 className="section-title">How the Referral Program Works</h2>
            <div className="step">
                <div className="icon--container blue-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                        <path d="M16 3.128a4 4 0 0 1 0 7.744"></path>
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                    </svg>
                </div>
                <div className="step-content">
                    <h3 className="step-title">1. Invite Friends</h3>
                    <p className="step-description">
                        Share your unique referral link or QR code with friends via social media, email, or messaging apps
                    </p>
                </div>
            </div>

            <div className="step">
                <div className="icon--container green-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                        <path d="M16 3.128a4 4 0 0 1 0 7.744"></path>
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                    </svg>
                </div>
                <div className="step-content">
                    <h3 className="step-title">2. They Sign Up</h3>
                    <p className="step-description">
                        When someone uses your link to regsiter, they become your referral automatically
                    </p>
                </div>
            </div>

            <div className="step">
                <div className="icon--container amber-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="12" x2="12" y1="2" y2="22"></line>
                        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                    </svg>
                </div>
                <div className="step-content">
                    <h3 className="step-title">3. Earn Rewards</h3>
                    <p className="step-description">
                        Get rewarded when your referrals complete their first plan purchase.
                    </p>
                </div>
            </div>
        </div>
            </Grid>
          </Grid>
              <div className="referral-right">
                <div className="referral-summary">
                  <Row className="refer-summary-cards">
                    <Col xl={2} lg={2} md={5} sm={5} xs={12}>
                      <div className="summary-card">
                        <div className="summary-icon total-reward">
                          <DollarSign size={24} />
                        </div>
                        <div className="summary-content">
                          <div className="summary-value">
                            {/* ${totalEarnings.toFixed(2)} */}
                            Coming soon
                          </div>
                          <div className="summary-label">Total Earning</div>
                        </div>
                      </div>
                    </Col>
                    <Col xl={2} lg={2} md={5} sm={5} xs={12}>
                      <div className="summary-card">
                        <div className="summary-icon total-leads">
                          <Users size={24} />
                        </div>
                        <div className="summary-content">
                          <div className="summary-value">{totalLeads}</div>
                          <div className="summary-label">Total Leads</div>
                        </div>
                      </div>
                    </Col>
                    <Col xl={2} lg={2} md={5} sm={5} xs={12}>
                      <div className="summary-card">
                        <div className="summary-icon total-conversion">
                          <TrendingUp size={24} />
                        </div>
                        <div className="summary-content">
                          <div className="summary-value">{totalConversion}</div>
                          <div className="summary-label">Total Conversion</div>
                        </div>
                      </div>
                    </Col>
                    <Col xl={2} lg={2} md={5} sm={5} xs={12}>
                      <div className="summary-card">
                        <div className="summary-icon in-progress">
                          <Clock size={24} />
                        </div>
                        <div className="summary-content">
                          <div className="summary-value">{inProgress}</div>
                          <div className="summary-label">In Progress</div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>

                {/* Users Table Section */}
                <div className="users-table-section">
                  <div className="table-header">
                    <h3 className="section-title">
                      Referred Users ({referralEarnings.length})
                    </h3>
                  </div>

                  <div className="table-container">
                    {referralEarnings.length > 0 ? (
                      <table className="users-table">
                        <thead>
                          <tr>
                            <th>Name</th>
                            {/* <th>Join Date</th> */}
                            {/* <th>Earnings</th> */}
                            <th>Email</th>
                          </tr>
                        </thead>
                        <tbody>
                          {referralEarnings.map((earning, index) => (
                            <tr key={earning.userID || index}>
                              <td>
                                <div className="user-info">
                                  <div className="user-details">
                                    <div className="user-name">
                                      {getUserName(earning.userDetail)}
                                    </div>
                                  </div>
                                </div>
                              </td>
                                    <td className="user-email">
                                      {earning.userDetail?.email || '_'}
                                    </td>
                              {/* <td className="date-cell">
                                {formatDate(earning.time)}
                              </td> */}
                              {/* <td className="earnings-cell">
                                Coming soon
                              </td> */}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <div style={{ textAlign: 'center', padding: '20px' }}>
                        <p>No referred users yet</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Refer;